export default __webpack_public_path__ + "0e84041f2384185147594ae31ce95ae4.png";